//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from 'echarts';
import { EleResize } from '@/utils/esresize'
export default {
    data() {
        return {
            components: [],
            tableParams: {
				pageNum: 1,
				pageSize: 10,
                startTime: null,
                endTime: null,
                imei: this.$route.query.M,
                modularId: null,
                modular: null,
                webId: this.$route.query.W,
                appId: this.$route.query.P,
                time: null
			},
            listLoading: false,
            dataList: [],
            tableTotal: 0,
            chartParams: {
                chartType: null,
            },
            chartLineBarData: {
                x: [],
                y: []
            },
            chartPieData: [],

            chartLineBar: null,
            optionLineBar: {
                title:{
                    text: ''
                },
                tooltip:{},
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ['line', 'bar'] },
                        saveAsImage: {},
                        myFull: { // 全屏
                            show: true,
                            title: '全屏',
                            icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: (e) => {
                                // 全屏查看
                                let domName = this.$refs.chartLineBar
                                if (domName.requestFullScreen) { // HTML W3C 提议
                                domName.requestFullScreen()
                                } else if (domName.msRequestFullscreen) { // IE11
                                domName.msRequestFullScreen()
                                } else if (domName.webkitRequestFullScreen) { // Webkit
                                domName.webkitRequestFullScreen()
                                } else if (domName.mozRequestFullScreen) { // Firefox
                                domName.mozRequestFullScreen()
                                }
                                // 退出全屏
                                if (domName.requestFullScreen) {
                                document.exitFullscreen()
                                } else if (domName.msRequestFullScreen) {
                                document.msExitFullscreen()
                                } else if (domName.webkitRequestFullScreen) {
                                document.webkitCancelFullScreen()
                                } else if (domName.mozRequestFullScreen) {
                                document.mozCancelFullScreen()
                                }
                            }
                        }
                    }
                },
                xAxis:{
                    type: 'category'
                },
                yAxis:{
                    type: 'value'
                },
                series:[{
                    type: 'line', //设置图表主题
                }],
            },
            chartPie: null,
            optionPie: {
                title:{
                    text: ''
                },
                tooltip:{},
                toolbox: {
                    show: true,
                    feature: {
                        dataView: { readOnly: false },
                        saveAsImage: {},
                        myFull: { // 全屏
                            show: true,
                            title: '全屏',
                            icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: (e) => {
                                // 全屏查看
                                let domName = this.$refs.chartPie
                                if (domName.requestFullScreen) { // HTML W3C 提议
                                domName.requestFullScreen()
                                } else if (domName.msRequestFullscreen) { // IE11
                                domName.msRequestFullScreen()
                                } else if (domName.webkitRequestFullScreen) { // Webkit
                                domName.webkitRequestFullScreen()
                                } else if (domName.mozRequestFullScreen) { // Firefox
                                domName.mozRequestFullScreen()
                                }
                                // 退出全屏
                                if (domName.requestFullScreen) {
                                document.exitFullscreen()
                                } else if (domName.msRequestFullScreen) {
                                document.msExitFullscreen()
                                } else if (domName.webkitRequestFullScreen) {
                                document.webkitCancelFullScreen()
                                } else if (domName.mozRequestFullScreen) {
                                document.mozCancelFullScreen()
                                }
                            }
                        }
                    }
                },
                series:[{
                    type: 'pie', //设置图表主题
                }],
            },
            showLineBar: true,
            showPie: true,
            showLineRadio: true,
            showBarRadio: true,
            showPieRadio: true,
            queryEchart: null,
            style: {
                xname: '',
                yname: '',
                sname: '',
                labelShow: false,
                legendShow: false,
            }
        }
    },
    created() {
        var token = this.$route.query.A
        if(token) {
            this.$store.commit('SET_STATUS', token)
            this.$store.commit('setEditMode', 'show')
            this.getComponentData()
        }
    },
    mounted() {
       this.drawCharts()
       this.showPie = false
       this.showLineBar = false
    },
    methods: {
        getComponentData() {
            let form = {
                imei: this.$route.query.M,
                appIdentification: this.$route.query.N,
                appSupplier: this.$route.query.E,
                appV: this.$route.query.V,
                devId: this.$route.query.D,
                appId: this.$route.query.P
            }
            this.request({
                url: '/web/dev-bid/view',
                method: 'post',
                data: form
            }).then(response => {
                let result = response.result.webString
                let componentData = JSON.parse(result.substring(1, result.length - 1).replaceAll('&nbsp;', ''))
                componentData.find(item => {
                    if((item.component == 'v-line' || item.component == 'v-bar' 
                    || item.component == 'v-pie' ||item.component == 'v-text'||item.component == 'v-gauge' || item.component == 'LineUPG' ||item.component == 'v-sector') && item.events.subscribe) {
                        this.components.push(item)
                    }
                })
            }).catch(error => {
                this.$message({
                    message: error.errmsg == undefined ? '页面解析异常' : error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
         
        },
        searchAction() {
            this.tableParams.pageNum = 1
            if(this.tableParams.modular == null || this.tableParams.time == null) {
                this.$message({
                    message: '请先选择组件和日期',
                    type: 'error',
                    duration: 3 * 1000
                })
            } else {
                this.tableParams.modularId = this.tableParams.modular.id
                this.tableParams.startTime = this.tableParams.time[0]
                this.tableParams.endTime = this.tableParams.time[1]
                this.queryEchart = this.tableParams.modular.component
                this.style = this.tableParams.modular.style
                if(this.tableParams.modular.component == 'v-text') {
                    this.showLineRadio = true
                    this.showBarRadio = true
                    this.showPieRadio = true
                    this.chartParams.chartType = null
                    this.showLineBar = false
                    this.showPie = false
                } else if(this.tableParams.modular.component == 'v-line') {
                    this.showLineRadio = true
                    this.showBarRadio = false
                    this.showPieRadio = false
                    this.chartParams.chartType = 'line'
                    // this.chartChange()
                    this.showLineBar = false
                    this.showPie = false
                } else if(this.tableParams.modular.component == 'v-bar') {
                    this.showLineRadio = false
                    this.showBarRadio = true
                    this.showPieRadio = false
                    this.chartParams.chartType = 'bar'
                    this.showLineBar = false
                    this.showPie = false
                } else if(this.tableParams.modular.component == 'v-pie') {
                    this.showLineRadio = false
                    this.showBarRadio = false
                    this.showPieRadio = true
                    this.chartParams.chartType = 'pie'
                    this.showLineBar = false
                    this.showPie = false
                }
                else if(this.tableParams.modular.component == 'v-gauge') {
                    this.showLineRadio = false
                    this.showBarRadio = false
                    this.showPieRadio = true
                    this.chartParams.chartType = 'gauge'
                    this.showLineBar = false
                    this.showPie = false  
                }else if(this.tableParams.modular.component == 'LineUPG') {
                    this.showLineRadio = false
                    this.showBarRadio = false
                    this.showPieRadio = true
                    this.chartParams.chartType = 'LineUPG'
                    this.showLineBar = false
                    this.showPie = false
                }
                this.fetchData()
            }
        },
        fetchData() {
            this.listLoading = true
            this.request({
                url: '/web/persistence/page',
                method: 'post',
                data: this.tableParams
            }).then(response => {
                this.tableTotal = response.total
                this.dataList = response.rows
                this.listLoading = false
            }).catch(error => {
                this.listLoading = false
                this.$message({
                    message: error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
        exportData() {
            if(this.tableParams.modular == null || this.tableParams.time == null) {
                this.$message({
                    message: '请先选择组件和日期',
                    type: 'error',
                    duration: 3 * 1000
                })
                return
            } else {
                this.tableParams.modularId = this.tableParams.modular.id
                this.tableParams.startTime = this.tableParams.time[0]
                this.tableParams.endTime = this.tableParams.time[1]
            }
            this.request({
                url: '/web/persistence/export',
                method: 'post',
                data: this.tableParams,
                responseType: "blob"
            }).then(response => {
                // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                let blob = new Blob([response.data], {type: response.data.type});
                // 创建一个a标签
                const link = document.createElement('a')
                // 设置a标签的下载属性
                let modular = this.tableParams.modular
                link.download = modular.propValue == '' ? modular.label : modular.label + '-' + modular.propValue + '.xlsx'
                // 将a标签设置为隐藏
                link.style.display = 'none';
                // 把之前处理好的地址赋给a标签的href
                link.href = URL.createObjectURL(blob);
                // 将a标签添加到body中
                document.body.appendChild(link);
                // 执行a标签的点击方法
                link.click();
                // 下载完成释放URL对象
                URL.revokeObjectURL(link.href)
                // 移除a标签
                document.body.removeChild(link)
            }).catch(error => {
                this.$message({
                    message: error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
        sizeChange(val) {
            this.tableParams.pageNum = 1
            this.tableParams.pageSize = val
            this.fetchData()
        },
        pageChange(val) {
            this.tableParams.pageNum = val
            this.fetchData()
        },
        chartChange() {
            if(this.tableParams.modular.component == 'v-text') {
                if(this.chartParams.chartType == 'pie') {
                    this.chartPieData.length = 0
                    for(var i = 0; i < this.dataList.length; i++) {
                        var obj = {
                            name: this.dataList[i].persistenceTime,
                            value: this.dataList[i].persistenceData
                        }
                        this.chartPieData.push(obj)
                    }
                    this.showPie = true
                    this.showLineBar = false
                    this.chartPie.setOption({
                        series: [{
                            type: this.chartParams.chartType, //设置图表主题
                            data: this.chartPieData,
                            label: {
                                show: false
                            }
                        }],
                    });
                } else {
                    this.chartLineBarData.x.length = 0
                    this.chartLineBarData.y.length = 0
                    for(var i = 0; i < this.dataList.length; i++) {
                        this.chartLineBarData.y.push(this.dataList[i].persistenceData)
                        this.chartLineBarData.x.push(this.dataList[i].persistenceTime)
                    }
                    this.showPie = false
                    this.showLineBar = true
                    this.chartLineBar.setOption({
                        xAxis: {
                            type: 'category',
                            data: this.chartLineBarData.x
                        },
                        series: [{
                            type: this.chartParams.chartType, //设置图表主题
                            data: this.chartLineBarData.y,
                            label: {
                                show: false
                            }
                        }],
                    });
                }
            } else if(this.tableParams.modular.component == '') {
                // 间隔一秒自动展示折线图
                // let self = this
                // let i = 0
                // let timer = setInterval(function() {
                //     let lineData = JSON.parse(self.dataList[i].persistenceData)
                //     self.chartLineBar.setOption({
                //         xAxis:{
                //             type: 'category',
                //             data: lineData.x
                //         },
                //         series:[{
                //             type: self.chartParams.chartType, //设置图表主题
                //             data: lineData.y,
                //         }],
                //     });
                //     i++
                //     if(i == self.dataList.length) {
                //         clearInterval(timer)
                //     }
                // }, 1000)
            }
            
        },
        drawCharts() {
            //基于准本好的DOM，初始化echarts实例
            this.chartLineBar = echarts.init(this.$refs.chartLineBar)
            this.chartPie = echarts.init(this.$refs.chartPie)

            // 自适应
            let self = this
            var listenerLineBar = function() {
                self.chartLineBar.resize()
            }
            var listenerPie = function() {
                self.chartPie.resize()
            }
            EleResize.on(this.$refs.chartLineBar, listenerLineBar)
            EleResize.on(this.$refs.chartPie, listenerPie)

            this.chartLineBar.setOption(this.optionLineBar)
            this.chartPie.setOption(this.optionPie)
            
        },
        showChart(row) {
            if(this.queryEchart == 'v-line' || this.queryEchart == 'v-bar' ) {
                this.showLineBar = true
                this.showPie = false
                let data = JSON.parse(row.persistenceData)
                this.chartLineBar.setOption({
                    xAxis: {
                        type: 'category',
                        data: data.x,
                        name: this.style.xname
                    },
                    yAxis: {
                        name: this.style.yname 
                    },
                    series: [{
                        type: this.chartParams.chartType,
                        data: data.y,
                        name: this.style.sname,
                        label: {
                            show: this.style.labelShow
                        }
                    }],
                    legend: {
                        show: this.style.legendShow,
                    },
                });
            } 
            else if(this.queryEchart == 'v-pie') {
                this.showLineBar = false
                this.showPie = true
                let data = JSON.parse(row.persistenceData)
                this.chartPie.setOption({
                    series: [{
                        type: this.chartParams.chartType,
                        data: data.data,
                        name: this.style.sname,
                        label: {
                            show: this.style.labelShow
                        }
                    }],
                    legend: {
                        show: this.style.legendShow,
                    },
                });
            }
            else if(this.queryEchart == 'v-gauge') {
                this.showLineBar = false
                this.showPie = true
                let data = JSON.parse(row.persistenceData)
                this.chartPie.setOption({
                    series: [{
                        type: this.chartParams.chartType,
                        data: data.data,
                        name: this.style.sname,
                        label: {
                            show: this.style.labelShow
                        }
                    }],
                    legend: {
                        show: this.style.legendShow,
                    },
                });
            }
        }
    }
}
